import { render } from "./TaskWidget.vue?vue&type=template&id=0975d1fc&scoped=true"
import script from "./TaskWidget.vue?vue&type=script&lang=ts"
export * from "./TaskWidget.vue?vue&type=script&lang=ts"

import "./TaskWidget.vue?vue&type=style&index=0&id=0975d1fc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0975d1fc"

export default script